var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('exportComponents',{ref:"exportComponents",attrs:{"exportCode":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }